/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.services.module.ts" />

module App.Common.Services {
	'use strict';

	export class ValidationElementModifierService {

		public key = 'customValidationModifier';

		public makeValid(el: angular.IAugmentedJQuery): void {
			this.makeDefault(el);
		}

		public makeInvalid(el: angular.IAugmentedJQuery, errorMsg: string): void {
			el.closest('.form-group').addClass('validation-error');

			let errorEl: JQuery;

			if (el.siblings('label, div.hint').length) {
				errorEl = el.siblings('div.error').first();
				if (!errorEl.length) {
					el.siblings('label, div.hint')
						.last()
						.after(`<div class=\"error\"></div>`);
					errorEl = el.siblings('div.error').first();
				}
			} else {
				errorEl = el.parent('.input-group').siblings('div.error').first();
				if (!errorEl.length) {
					el.parent('.input-group')
						.siblings('label, div.hint')
						.last()
						.after(`<div class=\"error\"></div>`);
					errorEl = el.parent('.input-group').siblings('div.error').first();
				}
			}

			errorEl.html(errorMsg);
		}

		public makeDefault(el: angular.IAugmentedJQuery): void {
			if (el.siblings('label, div.hint').length) {
				el.siblings('div.error').remove();
			} else {
				el.parent('.input-group').siblings('div.error').remove();
			}
			if (!el.closest('.form-group').find('div.error').length) {
				el.closest('.form-group').removeClass('validation-error');
			}
		}
	}

	function factory() {
		return new ValidationElementModifierService();
	}

	angular
		.module('app.common.services')
		.factory('app.common.services.validationElementModifierService', factory);
}